import tableModule from './modules/table';

const state = {
  ...tableModule.state,
  currentTableAuthor: null,
  currentTableDateFrom: null,
  currentTableDateTo: null,
  previous: {
    ...tableModule.state.previous,
    author: null,
    dateFrom: null,
    dateTo: null,
  },
};

const getters = {
  ...tableModule.getters,
};

const actions = {
  ...tableModule.actions,

  saveTableCurrentFilters(context) {
    tableModule.actions.saveTableCurrentFilters(context);

    context.dispatch('setPreviousVisitTableFilters');
    context.dispatch('setCurrentVisitTableFilters', true);
  },

  retrieveTablePreviousFilters(context) {
    tableModule.actions.retrieveTablePreviousFilters(context);

    context.dispatch('setCurrentVisitTableFilters');
    context.dispatch('setPreviousVisitTableFilters', true);
  },

  setCurrentVisitTableFilters(context, clear = false) {
    context.commit('SET_CURRENT_VISIT_TABLE_FILTERS', {
      author: clear ? null : context.state.previous.author,
      dateFrom: clear ? null : context.state.previous.dateFrom,
      dateTo: clear ? null : context.state.previous.dateTo,
    });
  },

  setPreviousVisitTableFilters(context, clear = false) {
    context.commit('SET_PREVIOUS_VISIT_TABLE_FILTERS', {
      author: clear ? null : context.state.currentTableAuthor,
      dateFrom: clear ? null : context.state.currentTableDateFrom,
      dateTo: clear ? null : context.state.currentTableDateTo,
    });
  },

  setCurrentTableAuthor(context, value) {
    context.commit('SET_CURRENT_TABLE_AUTHOR', value);
  },

  setCurrentTableDateFrom(context, value) {
    context.commit('SET_CURRENT_TABLE_DATE_FROM', value);
  },

  setCurrentTableDateTo(context, value) {
    context.commit('SET_CURRENT_TABLE_DATE_TO', value);
  },
};

const mutations = {
  ...tableModule.mutations,

  SET_CURRENT_TABLE_AUTHOR(state, author) {
    state.currentTableAuthor = author;
  },

  SET_CURRENT_TABLE_DATE_FROM(state, dateFrom) {
    state.currentTableDateFrom = dateFrom;
  },

  SET_CURRENT_TABLE_DATE_TO(state, dateTo) {
    state.currentTableDateTo = dateTo;
  },

  SET_CURRENT_VISIT_TABLE_FILTERS(state, { author, dateFrom, dateTo }) {
    state.currentTableAuthor = author;
    state.currentTableDateFrom = dateFrom;
    state.currentTableDateTo = dateTo;
  },

  SET_PREVIOUS_VISIT_TABLE_FILTERS(state, { author, dateFrom, dateTo }) {
    state.previous.author = author;
    state.previous.dateFrom = dateFrom;
    state.previous.dateTo = dateTo;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
